import { NavigationMetaType } from "app/types/navigationType";

export const findCompetitionDetails = (
  sports: NavigationMetaType[],
  competitionId: number
) => {
  for (const sport of sports) {
    for (const country of sport.nodes || []) {
      const competition = (country.nodes || []).find(
        comp => comp.id === competitionId
      );
      if (competition) {
        return {
          sport,
          country,
          competition,
        };
      }
    }
  }
  return null;
};

export const findCountryDetails = (
  sport: NavigationMetaType,
  countryId: number
) => {
  if (!sport?.nodes) return null;

  const country = sport.nodes.find(country => country.id === countryId);
  if (country) {
    return {
      sport,
      country,
    };
  }
  return null;
};
